function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable import/no-mutable-exports */
/* eslint-disable no-param-reassign */
// eslint-disable import/no-mutable-exports
import axios from 'axios';
import { buildSerializer, buildJSONAPIDeserializerInterceptor, JSONAPIAdapter } from '@unite-us/json-api-resources';
var APP_ENVIRONMENT = {};
var CALLBACKS = {};
var COMPONENTS = {};
var FEATURE_FLAGS = {};
var INITIAL_ADDRESSES = {};
var coreAxiosInstance;
var coreApi;
function setupAxiosInstanceDefaults(url) {
  var instance = axios.create({
    baseURL: url
  });
  instance.defaults.headers['X-EMPLOYEE-ID'] = APP_ENVIRONMENT.employeeId;
  instance.defaults.headers['X-PROVIDER-ID'] = APP_ENVIRONMENT.providerId;
  instance.defaults.headers['X-Application-Source'] = 'app-create-referral';
  instance.interceptors.request.use(function (config) {
    config.headers.Authorization = "Bearer ".concat(APP_ENVIRONMENT.getAuthToken());
    return config;
  }, function (error) {
    return Promise.reject(error);
  });
  return instance;
}
var initApp = function initApp(appSettings, callbacks, components) {
  var env = appSettings.env,
    feature_flags = appSettings.feature_flags,
    initialAddresses = appSettings.initialAddresses;
  // SETTING UP APP ENVIRONMENT
  // {
  //   getAuthToken: function, used for setting the Authorization header on requests
  //   employeeId: string, used for setting the X-EMPLOYEE-ID header on requests
  //   providerId: string, used for setting the X-PROVIDER-ID header on requests
  //   isEmr: boolean: used for determining if the app is running is EMR
  // },
  APP_ENVIRONMENT = _objectSpread({}, env);
  if (!callbacks.trackEventCallback) {
    throw new Error('trackEventCallback is required in order to run APP-CREATE-REFERRAL');
  }
  CALLBACKS = {
    // notify callback is used to display notifications to the user,
    // usually toasts
    // expect the following shape for the 'notify' object:
    // {
    //   success: PropTypes.func,
    //   error: PropTypes.func,
    //   warn: PropTypes.func,
    // }
    notify: callbacks.notify,
    // TrackEvent to send analytics event
    trackEvent: callbacks.trackEvent,
    // Function called after the referral is created (Review step)
    onReferralCompleted: callbacks.onReferralCompleted,
    // Called on Add Resources step and back button to navigate back to Search
    onNavigateBack: callbacks.onNavigateBack,
    // Called on Referral Builder step to navigate to Add Resources
    onNavigateToAddResources: callbacks.onNavigateToAddResources,
    // Function called to redirect after saving a draft referral
    onClearDraftReferral: callbacks.onClearDraftReferral,
    // Function called to redirect after saving a draft referral
    onSaveDraftReferral: callbacks.onSaveDraftReferral,
    // Update Search shopping cart when removing a program.
    onDeselectProgram: callbacks.onDeselectProgram,
    // Function called after the consent form is submitted (Review step)
    onSubmitConsent: callbacks.onSubmitConsent,
    // Functions called in ConsentDialog
    consent: callbacks.consent
  };
  COMPONENTS = {
    Consent: components === null || components === void 0 ? void 0 : components.consent,
    ShareDrawer: components === null || components === void 0 ? void 0 : components.ShareDrawer
  };
  FEATURE_FLAGS = _objectSpread({}, feature_flags);
  coreAxiosInstance = setupAxiosInstanceDefaults(env.coreUrl);

  // SETTING UP CORE ENDPOINT
  // creates a new serializer object using the buildSerializer() function.
  // Serializers are used to convert JavaScript objects into JSON API format and vice versa
  var serializer = buildSerializer();
  // creates a new interceptor object that deserializes JSON API responses.
  // Interceptors are used to modify HTTP requests and responses.
  var JSONAPIDeserializerInterceptor = buildJSONAPIDeserializerInterceptor(serializer);
  // adds the interceptor to the Axios instance's response interceptors.
  // This means that the JSONAPIDeserializerInterceptor
  // will be applied to all responses received by the instance.
  coreAxiosInstance.interceptors.response.use(JSONAPIDeserializerInterceptor);
  // This line creates a new JSONAPIAdapter object using the Axios instance and serializer objects.
  // The JSONAPIAdapter object is used to make HTTP requests
  // and handle the serialization/deserialization of data in the JSON API format.
  coreApi = new JSONAPIAdapter(coreAxiosInstance, serializer);
  INITIAL_ADDRESSES = initialAddresses;
  return true;
};
export { initApp, coreAxiosInstance, coreApi, APP_ENVIRONMENT, CALLBACKS, COMPONENTS, FEATURE_FLAGS, INITIAL_ADDRESSES };
//# sourceMappingURL=config.js.map